import {
  $http,
  Get,
  Post,
  Put,
  Patch,
  Delete,
  RequestUse
} from 'skytech-request'
import { init as domainInit, getRequestUse, getDomain } from 'sky-domain'
domainInit("oa", process.env.NODE_ENV)
window.getRequestUse = getRequestUse
window.getDomain = getDomain

RequestUse(window.getRequestUse);

$http.defaults.validateStatus = function (status) {
  return status >= 200 && status < 400;
}

export {
  Get,
  Post,
  Put,
  Patch,
  Delete
}



// WEBPACK FOOTER //
// ./src/services/base/baseAjax.js